import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Modal, ModalContainer, ModalHeader, Typography } from "@aviary";
import { Size } from "@shared/types/sizes";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./DemoVideoModal.styles";

interface Props {
  showDemoModal: boolean;
  setShowDemoModal: (value: boolean) => void;
}

const DemoVideoModal: FC<Props> = ({ showDemoModal, setShowDemoModal }) => {
  const { t } = useTranslation();

  return (
    <Modal isSize={Size.MEDIUM} isOpen={showDemoModal} onClose={() => setShowDemoModal(false)}>
      <ModalContainer>
        <ModalHeader>
          <Typography type="h2">
            {t(l.practitionerSignUp.peerReferral.demoVideoModalTitle)}
          </Typography>
        </ModalHeader>
        <iframe
          src={t(l.practitionerSignUp.peerReferral.demoVideoLink)}
          title={t(l.practitionerSignUp.peerReferral.demoVideoTitle)}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          css={styles.video}
        />
      </ModalContainer>
    </Modal>
  );
};

export { DemoVideoModal };
